export const validarIBAN = (iban) => {
    if (!iban) return false;

    const ibanSinEspacios = iban.replace(/\s+/g, '').toUpperCase();
    if (!/^ES\d{22}$/.test(ibanSinEspacios)) return false;

    // Reordenar IBAN
    const rearranged = ibanSinEspacios.slice(4) + ibanSinEspacios.slice(0, 4);

    // Convertir letras a números (A=10, B=11, ..., Z=35)
    const numericIban = rearranged
        .split('')
        .map(char => {
            const code = char.charCodeAt(0);
            return code >= 65 && code <= 90 ? code - 55 : char;
        })
        .join('');

    // Evaluar módulo 97
    let remainder = numericIban;
    while (remainder.length > 2) {
        const block = remainder.slice(0, 9);
        remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
    }

    return parseInt(remainder, 10) % 97 === 1;
};
